import type { FaireProductEntity } from "../../entity_types/product";

export const p_5mthdzrcs3: FaireProductEntity = {
  token: "p_5mthdzrcs3",
  type: "product",
  name: "S’more Clicker Fidget Toy – 3D Printed Stress Relief Toy",
  brandToken: "b_d6qznhf5cn",
  brandName: "Maker Magic 3D Co",
  imageUrl:
    "https://cdn.faire.com/fastly/7d7fa60e63817285bc07c6a561bc7c334adb57848eecb3eb7b6baa9ce80904b8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/82d9b3482b0f7f5b59ff638a2e2c7669721433205379adffbd4b8000ee07f9f8.png",
  ],
  priceDollars: 3.9,
  description:
    "Meet the S’more Clicker Fidget Toy! This adorable, 3D printed s’more-inspired fidget toy gives you the satisfying click you didn’t know you needed. A perfect gift for kids, teens, or adults who love sensory toys—or just really love s’mores (but please don’t eat it 😉).\n\n✨ Features:\n3D durable printed design with realistic graham cracker, chocolate, and marshmallow layers\nSatisfying Click Sound – Super clicky and fun to press over and over\nCompact and lightweight—great for desks, backpacks, or pockets\n\n📌 Please Note:\nThis item is 3D printed, so minor layer lines and slight variations may occur. These are normal characteristics of the 3D printing process and make each piece unique without affecting function or appearance.\n\n⚠️ Safety Notice: \nContains small parts that may pose a choking hazard. Not intended for children under 3 years of age. Adult supervision is recommended.\n",
  tags: [],
  msrpDollars: 6.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:38.844Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
